module.exports = "<div class=\"activation-page\">\n    <div class=\"container text-center\">\n\n        <h1>Activation de votre compte</h1>\n\n        <div *ngIf=\"activating\">\n            La vérification est en cours.\n        </div>\n\n        <div *ngIf=\"!activating && activated\">\n            Votre compte a bien été activé <i class=\"w20 icon icon-available\"></i>\n        </div>\n\n        <div *ngIf=\"!activating && !activated\">\n            Votre compte a déjà été activé <i class=\"w20 icon icon-unavailable\"></i>\n        </div>\n\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/business/activation/activation.component.html
// module id = 247
// module chunks = 0